import _defineProperty from "@babel/runtime/helpers/defineProperty";
import i from "./speedometer.js";
import m from "./throttle.js";
import f from "../utils.js";
var h = function h(t, o) {
    var a = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;
    var r = 0;
    var c = i(50, 250);
    return m(function (s) {
      var n = s.loaded,
        e = s.lengthComputable ? s.total : void 0,
        l = n - r,
        d = c(l),
        p = n <= e;
      r = n;
      var u = _defineProperty({
        loaded: n,
        total: e,
        progress: e ? n / e : void 0,
        bytes: l,
        rate: d || void 0,
        estimated: d && e && p ? (e - n) / d : void 0,
        event: s,
        lengthComputable: e != null
      }, o ? "download" : "upload", !0);
      t(u);
    }, a);
  },
  v = function v(t, o) {
    var a = t != null;
    return [function (r) {
      return o[0]({
        lengthComputable: a,
        total: t,
        loaded: r
      });
    }, o[1]];
  },
  C = function C(t) {
    return function () {
      for (var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++) {
        o[_key] = arguments[_key];
      }
      return f.asap(function () {
        return t.apply(void 0, o);
      });
    };
  };
export { C as asyncDecorator, v as progressEventDecorator, h as progressEventReducer };
